export default __webpack_public_path__ + "static/media/image05.9b7dd4cc.jpg";